import {
  merlinActions, onboardingActions, preChatActions,
} from '@/redux/modules';
import React, {
  useCallback, useEffect, useMemo, useRef, useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Styles from './AiChat.styles';
import { AiInitScreen } from './components/AiInitScreen';
import {
  COUNTRY, ENVIRONMENT, IS_PROD,
  TEAM,
  WHMCS_URL,
  WSS_AI_ENV,
} from '@/config';
import useLocale from '@/hooks/useLocale';
import {
  Button, IconArrow, IconClose, IconMinus, Tag, IconExpand,
  Tooltip,
  IconEllipsis,
  IconAudioRecord,
  IconMiniminize,
  IconDanger,
} from 'gatorcomponents';
import { ChatHistory } from './components/ChatHistory';
import {
  ALERTS_ACTIONS,
  DEVELOPMENT_ENV, INTERNAL_REDIRECT_OPTIONS, SCREENS, WSS_ROUTES,
} from './AiChat.enum';
import { useFeatureIsOn, useFeatureValue } from '@growthbook/growthbook-react';
import {
  ATIVACAO_AICHAT_AUDIO_RECORDING,
  ATIVACAO_AICHAT_RATING_SURVEY,
  ATIVACAO_DISABLE_TEXTEAREA_IF_OPTIONS, ATIVACAO_N8N_INHOUSE_INITIAL_SCREEN, ATIVACAO_N8N_INHOUSE_URLS,
} from '@/config/GrowthBook/constants';
import IconAnimation from '@/components/BannerAI/media/AiAnimation.webp';
import MaiaIconImage from '@/media/MaiaIA/iconImage.png';
import { useHistory } from 'react-router';
import { AudioRecording } from './components/AudioRecording';
import { IconButton } from '@/pages/common/v1/IconButton';
import { TranscriptionSkeleton } from './components/AudioRecording/TrancriptionSkeleton';
import { collect } from '@/analytics';
import { SettingsPopover } from './components/SettingsPopover';
import { SideContent } from './components/SideContent';
import { useResize } from '@/hooks/useResize';
import { AiChatSurvey } from './components/AiChatSurvey';
import { useAiChat } from '@/hooks/AiChat';
import { Alerts } from './components/Alerts';
import { useAiWebSocket } from '@/contexts/AiWebSocket/useAiWebSocket';

let pingTimeout = null;
export const AiChat = ({
  handleClose,
  minimizedChat,
  handleToggleMinimize,
  visibleAiChat,
  setVisibleAiChat,
  renderInHouseChat,
}) => {
  // const restartIntervalRef = useRef(null);

  const dispatch = useDispatch();

  const {
    hasConnection,
    disabledForReconnect,
    connectToWs,
    loading,
    loadingMessage,
    setLoading,
    setLoadingMessage,
    socket,
    closeSocket,
  } = useAiWebSocket();

  const {
    token,
    chatHistory: history,
    audioTranscription,
    loadingTranscription,
    currentChat,
    maiaAgent,
    sideContent,
    externalMessage,
    externalAudioBlob,
    ratedMessages: storeRatedMessages,
    alerts,
    alertsTypes,
    loadingAlertsTypes,
    showAlerts,
  } = useSelector(state => state.merlin);

  const { id, firstname, email } = useSelector(state => state.summary);
  const { jwt } = useSelector(state => state.auth);

  const inhouseFeatures = useFeatureValue(ATIVACAO_N8N_INHOUSE_INITIAL_SCREEN);
  const wssToggleRoutes = useFeatureValue(ATIVACAO_N8N_INHOUSE_URLS);
  const initScreen = inhouseFeatures && inhouseFeatures.withHome ? SCREENS.INITIAL : SCREENS.CHAT_HISTORY;
  const disableIfOptions = useFeatureIsOn(ATIVACAO_DISABLE_TEXTEAREA_IF_OPTIONS);
  const canShowAudioButton = useFeatureIsOn(ATIVACAO_AICHAT_AUDIO_RECORDING);
  // const ttrWs = useFeatureValue(ATIVACAO_N8N_TIME_TO_RECONNECT);
  const withSurvey = useFeatureIsOn(ATIVACAO_AICHAT_RATING_SURVEY);

  const [currentScreen, setCurrentScreen] = useState(history.length ? SCREENS.CHAT_HISTORY : initScreen);
  const [merlinInput, setMerlinInput] = useState('');
  const [threadid, setThreadid] = useState((currentChat.threadid) || null);
  const [env, setEnv] = useState(null);
  const [route, setRoute] = useState(currentChat.route || (wssToggleRoutes && wssToggleRoutes.general) || WSS_ROUTES.GENERAL);
  const [recording, setRecording] = useState(false);
  const recorderRef = useRef(null);
  const chunksRef = useRef([]);
  const [ratedMessages, setRatedMessages] = useState(storeRatedMessages);
  const [showSurvey, setShowSurvey] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [isSitePreview, setIsSitePreview] = useState(false);
  const [isAnswered, setIsAnswered] = useState(false);
  const [rateMessageFn, setRateMessageFn] = useState(null);

  const [moreThanOneLine, setMoreThanOneLine] = useState(false);
  const inputRef = useRef(null);
  const inputFieldRef = useRef(null);

  const { aichat: generalChatLocale, marketing: marketingLocale, routes: routesLocale } = useLocale();
  const [aichatLocale, setAiChatLocale] = useState(generalChatLocale);
  const { handleOpenAlerts } = useAiChat();

  const redirectHistory = useHistory();

  const windowRect = useResize();
  const { width } = windowRect;
  const isMobile = width < 600;

  const localesMap = useMemo(() => ({
    general: generalChatLocale,
    marketing: { ...generalChatLocale, ...marketingLocale.maiaLocales },
  }), [generalChatLocale, marketingLocale]);

  const handleOpenHotjarSurvey = useCallback(() => {
    setShowSurvey(true);
    collect({
      event: 'aiChatHotJar',
      gaEventCategory: 'Como você avalia a ajuda da Maia?',
      gaEventAction: 'Como você avalia a ajuda da Maia?',
      gaEventLabel: 'Como você avalia a ajuda da Maia?',
    });
  }, []);

  const updateCurrentChatStore = useCallback(() => {
    dispatch(merlinActions.inhouse.setCurrentChatState({
      route,
      fullScreen: currentChat.fullScreen,
      threadid,
    }));
  }, [
    dispatch,
    route,
    threadid,
    (currentChat.fullScreen),
  ]);

  useEffect(() => {
    updateCurrentChatStore();
  }, [updateCurrentChatStore]);

  const handleEnv = useCallback(() => {
    if (ENVIRONMENT === 'development') {
      if (WSS_AI_ENV) {
        return setEnv(WSS_AI_ENV);
      }
      return setEnv('homolog');
    }

    if (ENVIRONMENT === 'production') {
      return setEnv('production');
    }
  }, []);

  useEffect(() => {
    handleEnv();
  }, [handleEnv]);

  const updateHistory = useCallback(({ message, src }) => {
    const BotMessage = {
      ...message,
      src,
    };
    dispatch(merlinActions.inhouse.setMessage(BotMessage));
  }, [
    dispatch,
  ]);

  const handleCloseClick = useCallback(({ withTimeout = true }) => {
    handleToggleMinimize(false);
    setVisibleAiChat(false);

    if (withTimeout) {
      setTimeout(() => {
        handleClose && handleClose();
      }, 350);
    }

    if (!withTimeout) {
      handleClose && handleClose();
    }

    dispatch(merlinActions.alerts.showAlerts(false));
  }, [
    handleClose,
    handleToggleMinimize,
    setVisibleAiChat,
    dispatch,
  ]);

  const handleOpenSupport = useCallback(({ params }) => {
    dispatch(preChatActions.n8n.forceOpenSupport({ bool: true, n8nParams: params }));
  }, [
    dispatch,
  ]);

  const handleRedirectToMigration = useCallback((params) => {
    handleToggleMinimize(false);
    setVisibleAiChat(false);

    if (params) {
      dispatch(merlinActions.setMigrationData({
        hostingId: params.hosting_id,
        domain: params.domain,
        type: params.type,
      }));

      dispatch(onboardingActions.wizard.register.request({
        domain: params.domain,
        origin: 'ai_agents',
      }));

      redirectHistory.push(`${routesLocale.sitesPage}${routesLocale.sitesCreate}`);
      handleClose && handleClose();
    }
  }, [dispatch, redirectHistory, routesLocale.sitesCreate, routesLocale.sitesPage, handleToggleMinimize, setVisibleAiChat, handleClose]);

  const toggleFullScreen = useCallback(() => {
    dispatch(merlinActions.inhouse.toggleFullScreen());
  }, [dispatch]);

  const handleRedirect = useCallback(({ params }) => {
    if (params.url) {
      window.open(params.url, '_blank');
    }

    if (params.internal) {
      if (params.internal === INTERNAL_REDIRECT_OPTIONS.BILLING) {
        const isFullScreen = currentChat && currentChat.fullScreen;
        isFullScreen && toggleFullScreen();
        redirectHistory.push(`${routesLocale.invoices}${routesLocale.unpaid}`);
      }
    }
  }, [
    redirectHistory,
    routesLocale.invoices,
    routesLocale.unpaid,
    currentChat,
    toggleFullScreen,
  ]);

  const openSideContent = useCallback(({ url }) => {
    dispatch(merlinActions.inhouse.setSideContent({ isOpen: true, url }));
    !isMobile && dispatch(merlinActions.inhouse.setCurrentChatState({ fullScreen: true }));
  }, [dispatch, isMobile]);

  const closeAlerts = useCallback(() => {
    dispatch(merlinActions.alerts.showAlerts(false));
  }, [dispatch]);

  const executeAction = useCallback(({ action, params, msgData }) => {
    const actions = {
      closeChat: () => handleCloseClick({ withTimout: false }),
      openSupport: () => handleOpenSupport({ params }),
      migration: () => handleRedirectToMigration(params),
      redirect: () => handleRedirect({ params }),
      preview: () => {
        !isMobile && setIsSitePreview(true);
        !isMobile && openSideContent({ url: params.url });
        updateHistory({ message: msgData, src: 'bot' });
      },
      openAlerts: () => handleOpenAlerts(),
    };

    return actions[action]();
  }, [
    handleCloseClick,
    handleOpenSupport,
    handleRedirectToMigration,
    handleRedirect,
    openSideContent,
    isMobile,
    updateHistory,
    handleOpenAlerts,
  ]);

  const handleWsMessage = useCallback((message) => {
    const isArray = typeof message === 'object' && Array.isArray(message);

    const handleType = (msgData) => {
      const rules = {
        loading: () => { setLoading(true); setLoadingMessage(aichatLocale.loadingMessages[msgData.text] || aichatLocale.loadingMessages.default); },
        status: () => { setLoading(msgData.status === 'processing'); },
        text: () => { updateHistory({ message: msgData, src: 'bot' }); },
        options: () => { updateHistory({ message: msgData, src: 'bot' }); },
        action: () => { executeAction({ action: msgData.action, params: msgData.params, msgData }); },
        steps: () => {
          updateHistory({ message: msgData, src: 'bot' });
          if (msgData.params && msgData.params.withPreview) {
            !isMobile && setIsSitePreview(true);
            !isMobile && openSideContent({ });
          }
        },
        image: () => updateHistory({ message: msgData, src: 'bot' }),
        file: () => updateHistory({ message: msgData, src: 'bot' }),
        button: () => updateHistory({ message: msgData, src: 'bot' }),
      };

      if (rules[msgData.type]) {
        rules[msgData.type]();
      }
    };

    if (isArray) {
      message.forEach((msg) => {
        handleType(msg);
      });
    }

    if (!isArray) {
      handleType(message);
    }
  }, [
    updateHistory,
    setLoading,
    setLoadingMessage,
    executeAction,
    aichatLocale,
    isMobile,
    openSideContent,
  ]);

  const connectToWsRef = useRef(connectToWs);
  useEffect(() => { connectToWsRef.current = connectToWs; }, [connectToWs]);

  const handleWsMessageRef = useRef();
  useEffect(() => { handleWsMessageRef.current = handleWsMessage; }, [handleWsMessage]);

  const handleAlertAction = useCallback((alert) => {
    if (alert.type.slug === ALERTS_ACTIONS.WEBSITE_IS_NOT_CREATED) {
      const options = alert.elements.map(item => ({
        label: item.domain,
        value: `${aichatLocale.alerts['website-not-created'].createSiteOptionLabel}  ${item.domain}`,
      }));

      handleWsMessage({
        type: 'options',
        html: aichatLocale.alerts['website-not-created'].htmlMessage,
        options,
      });
    }

    if (alert.type.slug === ALERTS_ACTIONS.DOMAIN_IS_NOT_CONFIGURED) {
      const options = alert.elements.map(item => ({
        label: item.domain,
        value: `${aichatLocale.alerts['domain-not-configured'].configureDomainOptionLabel}  ${item.domain}`,
      }));

      handleWsMessage({
        type: 'options',
        html: aichatLocale.alerts['domain-not-configured'].htmlMessage,
        options,
      });
    }

    setCurrentScreen(SCREENS.CHAT_HISTORY);
    dispatch(merlinActions.alerts.showAlerts(false));
  }, [dispatch, aichatLocale, handleWsMessage]);

  const mountApiUrl = () => {
    if (IS_PROD) {
      return '';
    }

    if (ENVIRONMENT === 'development') {
      const isSquad = WSS_AI_ENV;

      if (isSquad) {
        return WHMCS_URL;
      }

      return DEVELOPMENT_ENV.URL;
    }

    return null;
  };

  const pingWs = useCallback(() => {
    clearTimeout(pingTimeout);
    const currentSocket = socket && socket.current && socket.current.readyState === 1;
    if (currentSocket) {
      socket.current.send(
        JSON.stringify({
          action: 'ping',
        }),
      );

      const oneMinute = 60000;
      pingTimeout = setTimeout(() => {
        pingWs();
      }, oneMinute);
    }
  }, [
    socket,
  ]);

  useEffect(() => {
    clearTimeout(pingTimeout);
    const oneMinute = 60000;
    pingTimeout = setTimeout(() => {
      pingWs();
    }, oneMinute);
  }, [pingWs]);

  const handleCloseSideContent = useCallback(() => {
    dispatch(merlinActions.inhouse.setSideContent({ isOpen: false }));
  }, [dispatch]);

  const handleCloseAlerts = useCallback(() => {
    dispatch(merlinActions.alerts.showAlerts(false));
  }, [dispatch]);

  useEffect(() => {
    setAiChatLocale(localesMap[maiaAgent] || localesMap.general);
  }, [maiaAgent, generalChatLocale, marketingLocale, localesMap]);

  useEffect(() => {
    if (currentChat && !currentChat.threadid) {
      const generatedThreadId = threadid || `thread_${Date.now().toString()}`;
      setThreadid(generatedThreadId);
    }
  }, [threadid, currentChat]);

  const entranceAnimation = () => {
    setTimeout(() => {
      setVisibleAiChat(true);
    }, 250);
  };

  useEffect(() => {
    entranceAnimation();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    !token && dispatch(merlinActions.requestMerlinToken());
  }, [dispatch, token]);

  const handleSubmitMerlin = useCallback((event, blockHistoryUpdate = false) => {
    const eventIsString = event && typeof event === 'string';

    if (!eventIsString) {
      event && event.preventDefault();
    }

    const messageContent = eventIsString ? event : merlinInput;

    const handleHistory = () => {
      if (!blockHistoryUpdate) {
        const clientMessage = {
          type: 'text',
          text: messageContent,
          src: 'client',
        };
        dispatch(merlinActions.inhouse.setMessage(clientMessage));
      }
      setMerlinInput('');
      setCurrentScreen(SCREENS.CHAT_HISTORY);
    };


    const sendToWs = () => {
      setLoading(true);
      const currentSocket = socket && socket.current && socket.current.readyState === 1;
      if (currentSocket) {
        socket.current.send(
          JSON.stringify({
            action: 'sendmessage',
            message: messageContent,
            token,
            accountId: `${id}`,
            threadId: threadid,
            name: firstname,
            email,
            env,
            route,
            apiUrl: mountApiUrl(),
            brand: COUNTRY.toLowerCase(),
            team: TEAM || undefined,
          }),
        );

        handleHistory();
      }

      if (!currentSocket) {
        setTimeout(() => {
          sendToWs();
        }, 1000);
      }
    };

    if (token && (merlinInput || eventIsString) && threadid) {
      if (!hasConnection) {
        connectToWs({
          duringSubmit: true, sendToWs, handleWsMessage,
        });
      }

      if (hasConnection) {
        sendToWs();
      }
    }
  }, [
    token,
    merlinInput,
    threadid,
    id,
    firstname,
    email,
    dispatch,
    route,
    env,
    connectToWs,
    socket,
    hasConnection,
    handleWsMessage,
    setLoading,
  ]);

  useEffect(() => {
    if (visibleAiChat && !disabledForReconnect && !externalMessage && !hasConnection) {
      const connectToWs = connectToWsRef.current;
      const onMessage = handleWsMessageRef.current;
      connectToWs && connectToWs({ duringSubmit: false, handleWsMessage: onMessage, sendToWs: null });
    }
  }, [visibleAiChat, disabledForReconnect, externalMessage, hasConnection]);

  useEffect(() => {
    const onExternalMessageReceived = () => {
      if (externalMessage && token && route && env && threadid) {
        handleSubmitMerlin(externalMessage, true);
        dispatch(merlinActions.inhouse.setExternalMessage(''));
      }
    };

    onExternalMessageReceived();
  }, [
    externalMessage,
    token,
    route,
    env,
    threadid,
    dispatch,
    handleSubmitMerlin,
  ]);

  const handleEnter = (event) => {
    const isShiftEnter = event.shiftKey && event.key === 'Enter';

    if (isShiftEnter || !merlinInput) {
      return;
    }

    if (event.key === 'Enter' && !event.shiftKey && merlinInput) {
      handleSubmitMerlin(event);
    }
  };

  const toggleMinimize = useCallback(() => {
    const isFullScreen = currentChat.fullScreen;
    const defaultFlow = () => {
      handleToggleMinimize(true);
      setVisibleAiChat(!visibleAiChat);
    };

    if (isFullScreen) {
      setIsSitePreview(false);
      dispatch(merlinActions.inhouse.setSideContent({ isOpen: false, url: undefined }));
      dispatch(merlinActions.alerts.showAlerts(false));
      toggleFullScreen();
      setTimeout(() => {
        defaultFlow();
      }, 500);
    }

    if (!isFullScreen) {
      defaultFlow();
    }
  }, [currentChat.fullScreen, handleToggleMinimize, visibleAiChat, setVisibleAiChat, dispatch, toggleFullScreen]);

  useEffect(() => {
    if (!currentChat.fullScreen && !isMobile) {
      dispatch(merlinActions.alerts.showAlerts(false));
      dispatch(merlinActions.inhouse.setSideContent({ isOpen: false, url: undefined }));
    }
  }, [currentChat.fullScreen, dispatch, isMobile]);

  const rateMessageAfterResponse = useCallback(() => {
    if (history && history.length > 1 && rateMessageFn) {
      rateMessageFn();
      setRateMessageFn(null);
    }
  }, [rateMessageFn, history]);

  useEffect(() => {
    rateMessageAfterResponse();
  }, [rateMessageAfterResponse]);

  const handleRateChat = ({ rating, message }) => {
    const rateMessage = () => {
      dispatch(merlinActions.rateChat({
        url: ENVIRONMENT === 'development' ? DEVELOPMENT_ENV.URL : undefined,
        env,
        threadId: threadid,
        accountId: id,
        rating,
        apiAuthKey: token,
        brandName: COUNTRY.toLowerCase(),
        ratingMessage: message,
      }));
    };

    if (history && history.length > 1) {
      rateMessage();
    }

    if (history && history.length <= 1) {
      setRateMessageFn(() => rateMessage);
    }
  };

  const handleRateMessage = ({ messageId, rating }) => {
    const ratings = [...ratedMessages];
    const existingRating = ratings.findIndex(item => item.messageId === messageId);

    if (existingRating !== -1) {
      ratings[existingRating] = { messageId, rating };
    } else {
      ratings.push({ messageId, rating });
    }

    setRatedMessages(ratings);

    dispatch(merlinActions.inhouse.rateMessage({
      url: ENVIRONMENT === 'development' ? DEVELOPMENT_ENV.URL : undefined,
      env,
      threadId: threadid,
      accountId: id,
      token: jwt,
      messageId,
      rating,
      apiAuthKey: token,
      brandName: COUNTRY.toLowerCase(),
      ratedMessages: ratings,
    }));
  };

  const isOptionsOrSteps = history
    && !!history.length
    && (history[history.length - 1].type === 'options' || history[history.length - 1].type === 'steps')
    && (disableIfOptions || history[history.length - 1].type === 'steps');

  const resetRecording = (recorder) => {
    if (!recorder || !recorder.stream) return;
    recorder.stream.getTracks().forEach(track => track.stop());
    recorderRef.current = null;
    chunksRef.current = [];
  };

  const sendAudio = useCallback((blob) => {
    const file = new File([blob], 'audio.wav');

    dispatch(merlinActions.inhouse.sendAudioMessage({
      file,
      token,
      accountId: id,
      threadId: threadid,
      env,
      brand: COUNTRY.toLowerCase(),
      url: ENVIRONMENT === 'development' ? DEVELOPMENT_ENV.URL : undefined,
    }));
  }, [dispatch, token, id, threadid, env]);

  const getTextWidth = (text, font) => {
    const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement('canvas'));
    const context = canvas.getContext('2d');
    context.font = font;
    const metrics = context.measureText(text);
    return metrics.width;
  };

  const handleInput = (text) => {
    const wrapper = inputRef.current;
    const textArea = inputFieldRef.current;
    if (!textArea) return;


    const style = getComputedStyle(inputFieldRef.current);
    const font = `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;

    const longestLine = text.split('\n').reduce((a, b) => (a.length > b.length ? a : b), '');

    const textWidth = Math.round(getTextWidth(longestLine, font));
    const maxHeight = 200;
    const actionsWidth = 88;
    const tolerance = 45;

    const wrapperWithTolerance = wrapper.offsetWidth - actionsWidth - tolerance;

    if (textWidth < wrapperWithTolerance) {
      textArea.style.width = `calc(100% - ${actionsWidth}px)`;
      setMoreThanOneLine(false);
    }

    if (textWidth >= wrapperWithTolerance) {
      textArea.style.width = '100%';
      const newHeight = Math.min(inputFieldRef.current.scrollHeight, maxHeight);
      textArea.style.height = `${newHeight >= maxHeight ? maxHeight : textArea.scrollHeight}px`;
      if (newHeight >= maxHeight) {
        textArea.style.overflow = 'auto';
      }
      setMoreThanOneLine(true);
    }
  };

  const handleOnChange = (e) => {
    setMerlinInput(e.target.value);
    handleInput(e.target.value);
  };

  useEffect(() => {
    if (externalAudioBlob && token && route && env && threadid) {
      sendAudio(externalAudioBlob);
      dispatch(merlinActions.inhouse.setExternalAudioBlob(null));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [externalAudioBlob, token, route, env, threadid]);

  const handleStartRecording = useCallback(() => {
    chunksRef.current = [];
    setRecording(true);

    navigator.mediaDevices.getUserMedia({ audio: true })
      .then((stream) => {
        const recorder = new MediaRecorder(stream);

        recorder.ondataavailable = (e) => {
          if (e.data.size > 0) {
            chunksRef.current.push(e.data);
          }
        };

        recorderRef.current = recorder;
        recorder.start();
      });
  }, []);

  const handleStopRecording = useCallback(({ cancelRecording }) => {
    const recorder = recorderRef.current;
    if (!recorder) return;

    setRecording(false);

    recorder.onstop = () => {
      if (!cancelRecording && chunksRef.current.length > 0) {
        const audioBlob = new Blob(chunksRef.current, { type: 'audio/wav' });
        sendAudio(audioBlob);
      }
      resetRecording(recorder);
    };

    recorder.stop();
  }, [sendAudio]);

  useEffect(() => {
    if (audioTranscription) {
      setMerlinInput(audioTranscription);
      dispatch(merlinActions.inhouse.clearAudioTranscription());
    }
  }, [audioTranscription, dispatch]);

  const shouldShowAudioRecord = recording || loadingTranscription;
  const isInputDisabled = loading || !token || isOptionsOrSteps || disabledForReconnect || shouldShowAudioRecord || !hasConnection;
  const isDisabledForm = loading || !token || isOptionsOrSteps || disabledForReconnect || !hasConnection;

  const mountForm = () => (
    <Styles.FormWrapper>
      <Styles.Form
        onSubmit={handleSubmitMerlin}
        $disabled={isDisabledForm}
        $isFullScreen={currentChat.fullScreen}
        ref={inputRef}
        $moreThanOneLine={moreThanOneLine}
      >
        {loadingTranscription && (
          <TranscriptionSkeleton />
        )}
        <Styles.TextArea
          lines="3"
          value={merlinInput}
          ref={inputFieldRef}
          onChange={handleOnChange}
          placeholder={aichatLocale.askMaiaPlaceholder}
          onKeyDown={handleEnter}
          disabled={isInputDisabled}
          autoFocus
          data-testid="textarea"
        />
        {!shouldShowAudioRecord && (
          <Styles.ActionsWrapper>
            {canShowAudioButton && (
            <IconButton
              icon={<IconAudioRecord size="md" color={isInputDisabled ? 'highDark' : 'lowDark'} />}
              onClick={handleStartRecording}
              testId="start-audio-recording"
              isDisabled={isInputDisabled}
            />
            )}
            <Styles.SubmitWrapper>
              <Button
                type="submit"
                variant="primary"
                width="fitContent"
                label={<IconArrow direction="top" />}
                disabled={!merlinInput || isOptionsOrSteps || disabledForReconnect || !hasConnection}
                testId="submit"
              />
            </Styles.SubmitWrapper>
          </Styles.ActionsWrapper>
        )}

        {shouldShowAudioRecord && (
        <AudioRecording
          onCancel={() => handleStopRecording({ cancelRecording: true })}
          onSend={() => handleStopRecording({ cancelRecording: false })}
          isRecording={recording}
          transcribing={loadingTranscription}
          locales={aichatLocale.audioRecording}
        />
        )}
      </Styles.Form>
    </Styles.FormWrapper>
  );

  const getAiInitScreenProps = () => ({
    name: firstname,
    aichatLocale,
    inhouseFeatures,
    setCurrentScreen,
    wssToggleRoutes,
    setRoute,
    handleSubmitMerlin,
    fullScreen: currentChat.fullScreen,
    mountForm,
    alertsTypes,
    loadingAlertsTypes,
    alertsCtaLocale: aichatLocale.alertsCta,
    isOptionsDisabled: isInputDisabled,
    alerts,
  });

  const openSitePreview = useCallback(({ url }) => {
    setIsSitePreview(true);
    openSideContent({ url });
  }, [openSideContent]);

  const getChatHistoryProps = () => ({
    history,
    locales: aichatLocale,
    loading,
    loadingMessage: loadingMessage || aichatLocale.loadingMessages.default,
    handleCloseClick,
    handleOpenSupport,
    handleRedirectToMigration,
    handleRedirect,
    renderInHouseChat,
    ratedMessages,
    setRatedMessages,
    handleRateMessage,
    fullScreen: currentChat.fullScreen,
    handleSubmitMerlin,
    openDocument: ({ url }) => { openSideContent({ url }); setIsSitePreview(false); },
    viewFullImage: aichatLocale.viewFullImage,
    name: aichatLocale.name,
    socket,
    openSitePreview,
    isFullScreen: currentChat.fullScreen,
    onToggleFullScreen: toggleFullScreen,
    handleOpenAlerts,
  });

  const screens = {
    initScreen: showAlerts
      ? <ChatHistory {...getChatHistoryProps()} />
      : <AiInitScreen {...getAiInitScreenProps()} />,
    chatHistory: <ChatHistory {...getChatHistoryProps()} />,
  };


  const getSettingsPopoverProps = useCallback(() => {
    const handleBackToSideContent = () => {
      handleCloseSideContent();
      handleCloseAlerts();
      setIsSitePreview(false);
      setTimeout(() => {
        toggleFullScreen();
      }, 500);
    };

    const handleClosePopoverSettings = () => {
      setShowSettings(false);
    };

    return ({
      label: aichatLocale.showMaiaOnInit,
      onClose: handleClosePopoverSettings,
      isFullScreen: currentChat.fullScreen,
      privacyPolicy: aichatLocale.privacyPolicy,
      termsOfUse: aichatLocale.termsOfUse,
      isSideContent: false,
      handleBackToSideContent,
    });
  }, [
    aichatLocale,
    currentChat,
    handleCloseSideContent,
    handleCloseClick,
    toggleFullScreen,
    handleCloseAlerts,
  ]);

  const getSideContentProps = () => ({
    isOpen: sideContent.isOpen,
    url: sideContent.url,
    locales: aichatLocale,
    isSitePreview,
    toggleMinimize,
    getSettingsPopoverProps,
  });

  const getAiChatSurveyProps = () => ({
    fullScreen: currentChat.fullScreen,
    handleRateChat,
    handleClose: () => setShowSurvey(false),
    isAnswered,
    setIsAnswered,
  });

  const handleUnmount = useCallback(() => {
    closeSocket && closeSocket();
  }, [closeSocket]);

  useEffect(() => () => {
    handleUnmount();
  }, [handleUnmount]);
  const getAlertsProps = useCallback(() => {
    const alertsWithLocales = () => alerts && alerts.map((alert) => {
      const newAlert = {
        ...alert,
        ...aichatLocale.alerts[alert.type.slug],
      };
      return newAlert;
    });

    const alertsLoaded = alertsTypes && Object.values(alertsTypes).every(alert => alert.loaded);
    return ({
      isOpen: showAlerts,
      alertsList: alertsWithLocales(),
      alertsTypes,
      handleAlertAction,
      getSettingsPopoverProps,
      toggleMinimize,
      closeAlerts,
      locales: aichatLocale,
      alertsLoaded,
    });
  }, [
    aichatLocale,
    handleAlertAction,
    showAlerts,
    getSettingsPopoverProps,
    toggleMinimize,
    closeAlerts,
    alerts,
    alertsTypes,
  ]);

  const isFullScreen = currentChat && currentChat.fullScreen;
  const hasAlerts = alerts && alerts.length > 0;
  const isInitScreen = currentScreen === SCREENS.INITIAL;
  const shouldRenderAlertsIcon = hasAlerts && (!isInitScreen || (isInitScreen && !isFullScreen));

  const alertsArrays = alertsTypes && Object.values(alertsTypes);
  const severity = alertsTypes && alertsArrays.some(alert => alert.severity === 'critical') ? 'critical' : 'warning';

  if (!renderInHouseChat) {
    return;
  }

  const defaultContent = () => (
    <>
      <Styles.Header $isFullScreen={currentChat.fullScreen}>
        {aichatLocale.name}
        <Tag label={aichatLocale.tag} variant="info" />

        {!showAlerts && (
          <Styles.ButtonsWrapper>
            {(currentChat && shouldRenderAlertsIcon) && (
            <Tooltip content={aichatLocale.tooltips.alerts} preferredPosition="bottomLeft">
              <Styles.RoundedButton onClick={handleOpenAlerts} $canShowButton={!sideContent.isOpen}>
                <Styles.SeverityDot $severity={severity} />
                <IconDanger size="sm" color="lowDark" />
              </Styles.RoundedButton>
            </Tooltip>
            )}

            {currentChat && !isMobile && (
            <Tooltip
              content={currentChat.fullScreen
                ? aichatLocale.tooltips.shrink
                : aichatLocale.tooltips.fullScreen
              }
              preferredPosition="bottomLeft"
            >
              <Styles.RoundedButtonForcedCenter
                onClick={toggleFullScreen}
                $hideInMobile
                $canShowButton={!sideContent.isOpen}
                $shouldForceCenter={!currentChat.fullScreen}
              >
                { currentChat.fullScreen
                  ? <IconMiniminize size="sm" color="lowDark" />
                  : <IconExpand size="sm" color="lowDark" />
                }
              </Styles.RoundedButtonForcedCenter>
            </Tooltip>
            )}

            {currentChat && (
            <Tooltip content={aichatLocale.tooltips.minify} preferredPosition="bottomLeft">
              <Styles.RoundedButton onClick={toggleMinimize} $canShowButton={!sideContent.isOpen}>
                <IconMinus size="sm" color="lowDark" />
              </Styles.RoundedButton>
            </Tooltip>
            )}

            {currentChat && (
            <Tooltip
              content={aichatLocale.tooltips.settings}
              preferredPosition="bottomLeft"
            >
              <Styles.RoundedButton onClick={() => setShowSettings(prevState => !prevState)} $canShowButton={!sideContent.isOpen}>
                <IconEllipsis color="lowDark" />
              </Styles.RoundedButton>
            </Tooltip>
            )}

            {currentChat && (
            <Tooltip content={aichatLocale.tooltips.close} preferredPosition="bottomLeft">
              <Styles.RoundedButton onClick={() => handleCloseClick({ withTimeout: true })} $canShowButton={!sideContent.isOpen}>
                <IconClose color="lowDark" />
              </Styles.RoundedButton>
            </Tooltip>
            )}
          </Styles.ButtonsWrapper>
        )}
      </Styles.Header>
      {showSettings && (
        <SettingsPopover {...getSettingsPopoverProps()} />
      )}

      {screens[currentScreen]}

      {((currentChat && !currentChat.fullScreen) || currentScreen === SCREENS.CHAT_HISTORY) && mountForm()}

      {(withSurvey && currentScreen !== SCREENS.INITIAL) && (
      <Styles.RatingSurveyWrapper id="aiChatSurvey">
        {showSurvey && (
          <AiChatSurvey {...getAiChatSurveyProps()} />
        )}

        {!showSurvey && (
          <Styles.SuveryRow $fullScreen={currentChat.fullScreen}>
            <Styles.SurveyLabel role="button">
              {aichatLocale.ratingSurveyLabel}
            </Styles.SurveyLabel>
            <Styles.SurveyCta onClick={handleOpenHotjarSurvey} role="button">
              {aichatLocale.ratingSurveyCta}
            </Styles.SurveyCta>
          </Styles.SuveryRow>
        )}
      </Styles.RatingSurveyWrapper>
      )}
    </>
  );

  if (currentChat.fullScreen) {
    return (
      <Styles.FullScreenWrapper>
        <Styles.FullScreenChatContainer>
          {defaultContent()}
        </Styles.FullScreenChatContainer>
        <SideContent {...getSideContentProps()} />
        <Alerts {...getAlertsProps()} />
      </Styles.FullScreenWrapper>
    );
  }

  return (
    <Styles.Wrapper $visible={visibleAiChat} $isFullScreen={currentChat.fullScreen}>
      <Styles.SlideInButton
        $visible={(!visibleAiChat && minimizedChat)}
        onClick={() => { !visibleAiChat && toggleMinimize(); }}
      >
        <Styles.MaiaIcon src={MaiaIconImage || IconAnimation} $marginTop />
        {aichatLocale.name}
      </Styles.SlideInButton>
      {defaultContent()}
      <SideContent {...getSideContentProps()} />
      <Alerts {...getAlertsProps()} />
    </Styles.Wrapper>
  );
};

export default AiChat;
